import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=34918fe9&scoped=true&lang=pug"
import script from "./Kiosk.vue?vue&type=script&lang=js"
export * from "./Kiosk.vue?vue&type=script&lang=js"
import style0 from "./Kiosk.vue?vue&type=style&index=0&id=34918fe9&prod&lang=scss"
import style1 from "./Kiosk.vue?vue&type=style&index=1&id=34918fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34918fe9",
  null
  
)

export default component.exports